<template>
  <teleport v-if="showModal" to="body">
    <div
      v-clickOutside="closeModal"
      class="fixed top-0 left-0 bg-upgrade-to-pro w-full h-full flex items-center justify-center"
      @click.stop
    >
      <div class="px-20 py-15 mx-20 md:mx-0" :class="isDarkMode ? 'bg-sidebar' : 'bg-white'">
        <div class="flex justify-end">
          <ButtonModule
            prefix="icon-close"
            :has-hover="true"
            class="text-18 text-app-color cursor-pointer"
            @click="closeModal"
          />
        </div>

        <div
          class="flex flex-col items-center text-grey-main md:px-100"
          :class="{ 'text-center': isMobile }"
        >
          <img
            v-if="!isMobile"
            :src="require(`@/assets/images/upgrade-to-pro.svg`)"
            class="max-w-180 w-full" alt=""
          >

          <p class="text-30 mt-30 mb-15 md:mb-20" :class="{ 'leading-small': isMobile }">Get hello ivy  <span class="font-bold">PRO</span> today.</p>

          <img :src="require(`@/assets/images/upgrade-to-pro-line.svg`)" class="max-w-450 w-full" alt="">

          <p class="mt-30">Make hello ivy a home for all your ideas, notes and pages.</p>

          <p class="mt-5">
            <span class="font-bold">Unlimited</span>
            <span class="italic"> spaces, pages</span> and
            <span class="italic">storage space</span> for just
            <span class="italic">$4 a month.</span>
          </p>

          <p class="mt-5 text-12 italic">
            (and you will support ongoing development)
          </p>

          <ButtonModule
            text="Upgrade to PRO."
            class="mt-30 mb-20 font-semibold rounded-4 px-40 py-18 bg-black-main text-white cursor-pointer"
            @click="upgradeToPro"
          />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { profileService } from '@/services'

export default {
  name: 'UpgradeToProOnboardingModal',

  components: {
    ButtonModule
  },

  data () {
    return {
      showModal: null
    }
  },

  /* COMPUTED */
  computed: {
    ...mapState({
      innerWidth: state => state.general.innerWidth,
      user: state => state.profile.user
    }),
    ...mapGetters(['isDarkMode', 'isMobile', 'isTeamAccount'])
  },

  created () {
    this.showModal = !this.isTeamAccount && (this.user?.profile.showUpgradeToPro === 2 || this.user?.profile.showUpgradeToPro === 6)
  },

  /* METHODS */
  methods: {
    ...mapActions(['upgrade', 'getProfile']),
    ...mapMutations(['loading', 'setNotification']),

    upgradeToPro () {
      if (this.user) {
        window.open(`https://helloivy.co/upgrade?userId=${this.user.id}`, '_blank')
      }
    },

    async closeModal () {
      try {
        const payload = {
          email: this.user.email,
          firstName: this.user.profile.firstName,
          lastName: this.user.profile.lastName,
          showUpgradeToPro: this.user.profile.showUpgradeToPro + 1
        }

        await profileService.update(payload)
        await this.getProfile()
        this.showModal = false
      } catch ({ data }) {
        this.setNotification({
          isVisible: true,
          message: data.error.message,
          color: 'error'
        })
      }
    }
  }
}
</script>
